<template>
  <div class="main-content">
    <div class="content-top">
      <select-meter class="card-shadow"></select-meter>
      <consumption-pie-chart class="card-shadow d-flex"></consumption-pie-chart>
    </div>
    <div class="content-bottom">
      <render-chart class="render-chart chart-padding" />
      <div class="other-cards">
        <div class="day-cost">
          <div class="card-title">
            <div class="card-icon"><img :src="base_url + '/images/icons/15.png'" alt=""></div>
            <span>當{{ translateTimeFormat(time_format) }}電費預估</span>
          </div>
          <div class="card-content">${{ electricity_bill }}</div>
        </div>
        <div class="day-consumption">
          <div class="card-title">
            <div class="card-icon"><img :src="base_url + '/images/icons/16.png'" alt=""></div>
            <span>當{{ translateTimeFormat(time_format) }}消耗</span>
          </div>
          <div class="card-content">
            <div class="circuits-data" v-for="meterUsage, index in dailyCircuitUsage" :key="index">
              <span>{{ meterUsage.alias }}</span><br>
              <span>&ensp;&ensp;{{ meterUsage.cumulative_ep }} kWh</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectMeter from './buttons/SelectMeter.vue';
import ConsumptionPieChart from './charts/ConsumptionPieChart.vue';
import ElectricityUsageLineChart from './charts/ElectricityUsageLineChart.vue';
import { axiosMixins } from './mixins/axiosErrorMessage';
import RenderChart from './charts/RenderChart.vue';
import { powerCostCalculation } from './mixins/powerCostCalculation';

export default {
  components: {
    SelectMeter,
    ConsumptionPieChart,
    ElectricityUsageLineChart,
    RenderChart
  },
  mixins: [axiosMixins, powerCostCalculation],
  data() {
    return {
      base_url: base_url,
      electricity_bill: null,
      isShowInput: false,
      region_name: "",
    };
  },
  mounted() {
  },
  computed: {
    dailyCircuitUsage() {
      const circuits = this.$store.getters.selectedMeter.bx_circuits;
      if (!circuits) { return null; }
      const circuit_keys = Object.keys(circuits);
      let data = [];
      let count = 0;

      for (let i = 0; i < circuit_keys.length; i++) {
        let cumulative_data = [];
        cumulative_data = circuits[i].cumulative_data.filter(value => value.cumulative_ep !== "");
        if (cumulative_data.length > 0) {
          let cumulative_ep = cumulative_data[cumulative_data.length - 1].cumulative_ep;
          if (i === 0) {
            this.electricity_bill = this.calculateElectricityBill(cumulative_ep, this.$store.getters.billMode);
          }
          data[count] = {
            alias: circuits[i].alias,
            cumulative_ep: Math.abs(cumulative_ep),
          };
          count++
        }
      }

      return data;
    },
    time_format() {
      return this.$store.getters.historicalDataTimeFormat;
    }
  },
  watch: {
    deep: true,
  },
  methods: {
    translateTimeFormat(time_format) {
      switch (time_format) {
        case "day":
          return "日";
        case "week":
          return "週";
        case "month":
          return "月";
        case "year":
          return "年";
        default:
          return;
      }
    },
  }
};
</script>

<style scoped>
.main-content {
  width: 100%;
  height: calc(100vh - 14.5vh);
}

.main-content .card-shadow {
  border-radius: 1rem;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.09);
  padding: 1%;
}

.main-content .chart-padding {
  padding: 0 2% 5% 2%;
}

.main-content .content-top,
.main-content .content-bottom {
  padding: 1%;
}

.main-content .content-top {
  display: flex;
  justify-content: space-between;
  height: 40%;
  min-height: 160px;
}

.main-content .content-top>div {
  width: 49%;
}

.main-content .content-bottom {
  display: flex;
  justify-content: space-between;
  height: 60%;
}

.main-content .content-bottom .render-chart {
  width: 70%;
}

.main-content .content-bottom .other-cards {
  width: 27%;
  min-width: 220px;
}

.main-content .content-bottom .other-cards>div {
  border-radius: .5rem;
}

.main-content .content-bottom .other-cards .card-title {
  display: flex;
  align-items: center;
  padding-left: 4%;
  margin: 0;
  min-height: 2.5rem;
  height: 15%;
}

.main-content .content-bottom .other-cards .card-title>span {
  color: white;
  font-size: .9rem;
  font-weight: bolder;
  margin-left: .5rem;
}

.main-content .content-bottom .other-cards .card-title .card-icon {
  width: 1.8rem;
  height: 1.8rem;
  background-color: white;
  border-radius: .3rem;
}

.main-content .content-bottom .other-cards .card-title .card-icon>img {
  margin: 15%;
  width: 70%;
  height: 70%;
}

.main-content .content-bottom .other-cards .card-content {
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  font-size: 1.2rem;
}

.main-content .content-bottom .other-cards .card-content .circuits-data {
  margin-bottom: 1%;
  min-width: 35%;
  max-width: 45%;
}

.main-content .content-bottom .other-cards .day-cost {
  background-color: #0287d6;
  height: 25%;
  margin-bottom: 2%;
}

.main-content .content-bottom .other-cards .day-consumption {
  background-color: #069610;
  height: 73%;
}

.main-content .content-bottom .other-cards .day-consumption>.card-content {
  font-size: .7rem;
  height: calc(100% - 2.5rem);
}

@media (min-width: 1300px) {
  .main-content .content-bottom .other-cards .card-content {
    font-size: 1.8rem;
  }

  .main-content .content-bottom .other-cards .card-content .circuits-data {
    margin: 1% 0 2% 0;
  }

  .main-content .content-bottom .other-cards .day-consumption>.card-content {
    font-size: .8rem;
  }
}

@media (min-width: 1400px) {
  .main-content .content-bottom .other-cards .card-title {
    min-height: 3rem;
  }

  .main-content .content-bottom .other-cards .card-title>span {
    font-size: 1.1rem;
  }

  .main-content .content-bottom .other-cards .card-title .card-icon {
    width: 2.1rem;
    height: 2.1rem;
  }

  .main-content .content-bottom .other-cards .card-content {
    font-size: 2rem;
  }

  .main-content .content-bottom .other-cards .card-content .circuits-data {
    margin: 1% 0 3% 0;
  }

  .main-content .content-bottom .other-cards .day-consumption>.card-content {
    font-size: .9rem;
  }
}

@media (max-height: 570px) {
  .main-content .content-bottom .other-cards .day-cost {
    display: flex;
    justify-content: space-between;
    height: 2.5rem;
  }

  .main-content .content-bottom .other-cards .day-cost .card-title {
    height: 100%;
  }

  .main-content .content-bottom .other-cards .day-cost .card-content {
    padding-right: 1.5rem;
    flex-direction: row;
    align-items: center;
    font-size: 1rem;
  }

  .main-content .content-bottom .other-cards .day-consumption {
    height: calc(100% - 2.5rem - 2%);
  }

  .main-content .content-bottom .other-cards .day-consumption>.card-content {
    font-size: .7rem;
    height: calc(100% - 2.5rem);
  }
}
</style>
